<template>
 <div>
     <div class="oneDiv">
           <img src="../../assets/images/load.jpg" alt="" class="loadImg">
     </div>
   
  </div>
</template>
<script>
    export default{
          name:"load",
            data(){
                 return{
          
                 }
           },
     
    }
</script>
<style scoped>
.oneDiv{
         width: 100%;
    height: 100%;
    top:0;
    z-index: -1; 
    position: absolute;
}
  .loadImg{
        display: block;
    outline: none;
    border:0;
    height: 100%;
    width: 100%;
      
   }
</style>




// WEBPACK FOOTER //
// src/components/loads/load.vue